import axios from 'axios';
import { clearUserData } from '../auth/authentication/Login';
import AppConstants from '../helpers/AppConstants';
import CadiCurriculumService from './cadi-curriculum-service';
import ContactService from './contact-service';
import InfoSessionService from './info-session-service';
import JobService from './job-service';
import MeetingService from './meeting-service';
import MessageService from './message-service';
import SchoolService from './school-service';
import UserService from './user-service';
import PipelineService from './pipeline-service';

const API = axios.create({
    baseURL: process.env.REACT_APP_ENRICH_CMS_ENDPOINT,
    timeout: 30000,
});

API.interceptors.request.use((config) => {
    const accessToken = localStorage.getItem(AppConstants.cacheKeys.authToken);
    return {
        ...config,
        headers: {
            ...config.headers,
            Authorization: accessToken ? `Bearer ${accessToken}` : null,
        },
    };
});

API.interceptors.response.use(
    (value) => value,
    (error) => {
        if (error.response?.status === 401) {
            clearUserData();
            window.location.href = '/login';
            return Promise.reject(error);
        } else if (error.response?.data?.error?.message) {
            throw new Error(error.response.data.error.message);
        } else {
            throw new Error(error);
        }
    },
);

export {
    API,
    CadiCurriculumService,
    ContactService,
    InfoSessionService,
    JobService,
    MeetingService,
    MessageService,
    SchoolService,
    UserService,
    PipelineService,
};
